import { createClient } from "@sanity/client";

const sanityToken = process.env.SANITY_API_READ_TOKEN;

export const sanityClient = createClient({
  projectId: "pntpjov7",
  dataset: "production",
  // TODO
  //   studioBasePath: "/admin",
  token: sanityToken,
  perspective: "published",
  // Set useCdn to false if you're building statically.
  useCdn: false,
  apiVersion: "2025-10-04",
});
